import React, { createContext, useState, useEffect } from 'react';
import { loucaApi } from '../services/loucaApi';

const DEFAULT_TOKEN = 'louca-certifia-2025';
const DEFAULT_USER_ID = 'DEMO_DRIVER';
const DEFAULT_USER = {
  user_id: DEFAULT_USER_ID,
  username: 'Demo Driver'
};

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);

  useEffect(() => {
    try {
      const savedUser = localStorage.getItem('louca_user');
      const savedToken = localStorage.getItem('louca_token');

      if (savedUser && savedToken) {
        setUser(JSON.parse(savedUser));
        setToken(savedToken);
      } else {
        // Bootstrap a default session for the public UI
        setUser(DEFAULT_USER);
        setToken(DEFAULT_TOKEN);
        localStorage.setItem('louca_user', JSON.stringify(DEFAULT_USER));
        localStorage.setItem('louca_token', DEFAULT_TOKEN);
      }
    } catch (error) {
      console.error('Failed to initialize auth context', error);
      setUser(DEFAULT_USER);
      setToken(DEFAULT_TOKEN);
    } finally {
      setLoading(false);
    }
  }, []);

  const login = async (user_id = DEFAULT_USER_ID) => {
    const newUser = {
      user_id,
      username: user_id
    };

    setUser(newUser);
    setToken(DEFAULT_TOKEN);

    localStorage.setItem('louca_user', JSON.stringify(newUser));
    localStorage.setItem('louca_token', DEFAULT_TOKEN);

    return { success: true };
  };

  const logout = () => {
    // Keep the app accessible; reset to the default demo session instead of clearing everything
    setUser(DEFAULT_USER);
    setToken(DEFAULT_TOKEN);
    localStorage.setItem('louca_user', JSON.stringify(DEFAULT_USER));
    localStorage.setItem('louca_token', DEFAULT_TOKEN);
  };

  const isAuthenticated = !!user && !!token;

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      token,
      login,
      logout,
      isAuthenticated,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = React.useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export default AuthContext;



